export interface GetAccountSentimentReportAverageSummaryResponseDto {
  averageRating: number;
  averageRatingDeviation: string;
}
